import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { ProgressBar } from '../../../ProgressBar';

export const $AttachmentContainer = styled.div`
  display: flex;
  flex: 1;
  height: ${spacing('xxl')};
  flex-direction: column;
  width: 100%;
  position: relative;
`;

export const $StyledProgressBar = styled(ProgressBar)`
  width: 100%;
  height: ${spacing('xxl')};
  border-width: 1px;
  border-color: ${({ isSuccess, isError, theme }) => {
    if (isError) {
      return theme.colors.danger;
    }

    if (isSuccess) {
      return theme.colors.success;
    }

    return theme.colors.lightGrey;
  }};
  border-style: solid;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  & > * :last-child {
    white-space: nowrap;
  }
`;

interface AttachmentContentProps {
  $fixed?: boolean;
}

export const $AttachmentContent = styled.div<AttachmentContentProps>`
  flex: ${({ $fixed }) => (!$fixed ? 1 : null)};
  min-width: ${({ $fixed }) => (!$fixed ? 0 : null)};
  max-width: ${({ $fixed }) => (!$fixed ? spacing(72) : null)};
  white-space: ${({ $fixed }) => ($fixed ? 'nowrap' : null)};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding-left: ${spacing('lg')};
`;

export const $AttachmentsListFileName = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  height: 100%;
  padding: 0 ${spacing('lg')};
  color: ${({ theme }) => theme.colors.mainTextColor};

  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
